// Sample / seed data used to bootstrap local state before API responses
// load. In production these get replaced by /api/users/lawyers etc.
//
// Long-term: this file should disappear entirely once every component
// fetches its initial data from the backend rather than seeding from
// constants.

import type { LawyerRow } from "./types/api";

export const LAWYERS: LawyerRow[] = [
  { id: "l1", name: "Sarah Chen", email: "s.chen@company.com", specialty: "Commercial" },
  { id: "l2", name: "Marcus Thompson", email: "m.thompson@company.com", specialty: "IP / Technology" },
  { id: "l3", name: "Elena Vasquez", email: "e.vasquez@company.com", specialty: "Data Privacy" },
  { id: "l4", name: "James Park", email: "j.park@company.com", specialty: "Procurement" },
];
